import {Component, ViewChild, AfterViewInit, NgModule, Inject, OnInit, ViewChildren, QueryList} from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { DashboardService } from '../../_services';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { AuthenticationService } from '../../_services';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar} from '@angular/material/snack-bar';
import { first } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.html',
  styleUrls: ['./dashboards.component.scss']
})

export class DashboardsComponent implements OnInit{

  public filtro: any;
  public colores;
  user: any;
  public graficas:any;
  public temporalidad:any;
  public graficas_configuradas: any;
  gridColumns = 2;
  current_user: any;
  ml_refresh_token_expirations: any[] = []
  tik_tok_refresh_token_expirations: any[] = []
  metabaseUrl: SafeResourceUrl = null;
  isLoading = false;
  hasError = false;

  constructor(
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private DashboardService: DashboardService,
    private router: Router,
    private snackBar: MatSnackBar,
    private translate : TranslateService,
    private sanitizer: DomSanitizer
  ) {
    translate.setDefaultLang(localStorage.getItem('idioma'));
  }
  
  public onValChange(val: string) {
    this.filtro = val;
    if(this.graficas != ''){
      setTimeout(() => { 
        if(this.graficas != ''){
          this.graficas.forEach(element => {
            if(element.nombre_grafica =="myChartEnviosTotales"){              
              let filtro = "0";
              if(element.tiempo == 0){
                filtro = this.filtro;
              }else{
                filtro = element.tiempo;
              }
              this.consultarTotales(this.user["seller_id"],filtro,element.tipo_grafica,element.alias_grafica);
            }
            if(element.nombre_grafica =="myChartEnviosEstatus"){
              let filtro = "0";
              if(element.tiempo == 0){
                filtro = this.filtro;
              }else{
                filtro = element.tiempo;
              }
              this.consultarEstatus(this.user["seller_id"],filtro,element.tipo_grafica,element.alias_grafica);
            }
            if(element.nombre_grafica =="myChartEnviosPorcentaje"){
              let filtro = "0";
              if(element.tiempo == 0){
                filtro = this.filtro;
              }else{
                filtro = element.tiempo;
              }
              this.consultarEstatusPorcentaje(this.user["seller_id"],filtro,element.tipo_grafica,element.alias_grafica);
            }
            if(element.nombre_grafica =="myChartEntradasEstatus"){
              let filtro = "0";
              if(element.tiempo == 0){
                filtro = this.filtro;
              }else{
                filtro = element.tiempo;
              }
              this.consultarEstatusEntradas(this.user["seller_id"],filtro,element.tipo_grafica,element.alias_grafica);
            }
            if(element.nombre_grafica =="myChartDevolucionesEstatus"){
              let filtro = "0";
              if(element.tiempo == 0){
                filtro = this.filtro;
              }else{
                filtro = element.tiempo;
              }
              this.consultarEstatusDevoluciones(this.user["seller_id"],filtro,element.tipo_grafica,element.alias_grafica);
            }
            if(element.nombre_grafica =="myChartTicketsEstatus"){
              let filtro = "0";
              if(element.tiempo == 0){
                filtro = this.filtro;
              }else{
                filtro = element.tiempo;
              }
              this.consultarEstatusTickets(this.user["seller_id"],filtro,element.tipo_grafica,element.alias_grafica);
            }
            if(element.nombre_grafica =="myChartTicketsMotivo"){
              let filtro = "0";
              if(element.tiempo == 0){
                filtro = this.filtro;
              }else{
                filtro = element.tiempo;
              }
              this.consultarMotivoTickets(this.user["seller_id"],filtro,element.tipo_grafica,element.alias_grafica);
            }
            if(element.nombre_grafica =="myChartTotalEnviosStatus"){
              let filtro = "0";
              if(element.tiempo == 0){
                filtro = this.filtro;
              }else{
                filtro = element.tiempo;
              }
              this.consultarGraficaEstatusEnvios(this.user["seller_id"],filtro,element.tipo_grafica,element.alias_grafica);
            }
          });
        }
      }, 500);
    }
  }

  ngOnInit(){
    this.asignarDatos(); 
    this.authenticationService.currentUser.subscribe(x => this.user = x);
    this.filtro = "1"; //Día
    this.graficas_configuradas = false;
    this.colores = ["rgba(0, 35, 102)","rgba(155, 24, 124)","rgba(190, 35, 102)","rgba(0, 0, 0)","rgba(112, 108, 153)","rgba(58, 118, 232)","rgba(80, 0, 61)","rgba(70, 16, 57)","rgba(190, 60, 159)","rgba(17, 33, 63)","rgba(0, 65, 190)","rgba(26, 46, 84)"];
    this.temporalidad = [{id:0,descripcion:"Dinámico"},{id:1,descripcion:"Día"},{id:2,descripcion:"Semana"},{id:3,descripcion:"Mes"},{id:4,descripcion:"Año"},{id:5,descripcion:"Total"}];
    this.cargarDashboard();
    this.ml_refresh_token_expiration();   
    this.tik_tok_refresh_token_expiration(); 
  }

  reload(){
    this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/login']);
    });
  }

  guardar(datos,tipo_accion){
    this.DashboardService.guardarConfiguracionSeller(datos, this.user["seller_id"],tipo_accion)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.snackBar.open(data.message, "OK", {                      
            duration: 3500,
          });
          this.graficasSeller();
          this.reload();
        }else{
          this.snackBar.open(data.message, "OK", {                      
            duration: 4500,
          });
        }
      },
      error => {
        this.snackBar.open(error, "OK", {                      
          duration: 3500,
        });
      }
    );
  }

  valida_configuracion(datos,tipo_guardado){
    this.DashboardService.validaConfiguracionSeller(datos, this.user["seller_id"])
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.guardar(datos,tipo_guardado)
        }else{

          this.snackBar.open(data.message, "OK", {                      
            duration: 4500,
          });
        }
      },
      error => {
        this.snackBar.open(error, "OK", {                      
          duration: 3500,
        });
      }
    );
  }
  
  consultarTotales(item_id, filtro, tipo_grafica,alias_grafica){
    this.DashboardService.consultarEnviosTotales(item_id, filtro)
    .pipe()
    .subscribe(
      data => {
          if(data.status == 200){
            let totales = [];
            let labels = []; 
            let colores = [];
            let bordes = [];

              for(let i = 0; i<data.body.orden.length; i++){
                totales.push(parseInt(data.body.orden[i].total));
                labels.push(data.body.orden[i].descripcion);
                colores.push(this.colores[1]);
                bordes.push(this.colores[1]);
              }

            this.graficaTotalesEnvios(labels, totales, colores, bordes, tipo_grafica,alias_grafica);
          }
        },
      error => {}
    );
  }

  graficaTotalesEnvios(labels, totales, colores, bordes, tipo_grafica,alias_grafica){
    document.getElementById(alias_grafica).remove();
    var canvas = document.createElement("canvas");
    canvas.id = alias_grafica; 
    document.getElementById("contenedor"+alias_grafica).appendChild(canvas);
    var ctx = document.getElementById(alias_grafica) as HTMLCanvasElement;
    var myChartEnviosTotales = new Chart(ctx, {
        type: tipo_grafica,
        data: {
            labels: labels,
            datasets: [{
                label: '# envíos',
                data: totales,
                backgroundColor: colores,
                borderColor: colores,
                borderWidth: 1
            }]
        },
        options: {
          scales: {
            xAxes: [{
              barPercentage: 1,
              gridLines: {
                display: false
              },
              scaleLabel: {
                display: true,
                labelString: "Tiempo",
                fontColor: "black"
              }
            },],
            yAxes: [{
              gridLines: {
                zeroLineColor: "black",
                zeroLineWidth: 2
              },
              scaleLabel: {
                display: true,
                labelString: "Totales"
              },
              ticks: {
                beginAtZero: true
              }
            }]
          },
          elements: {
            rectangle: {
              borderSkipped: 'left',
            }
          }
        }
    });
  }

  consultarEstatus(item_id, filtro, tipo_grafica,alias_grafica){
    this.DashboardService.consultarEnviosEstatus(item_id, filtro)
    .pipe()
    .subscribe(
      data => {
          if(data.status == 200){

            let datos_completos = [];
            let labels = []; 
            let colores_fulfilled = [];
            let colores_unfullfiled = [];
            let colores_pausado = [];
            let colores_cancelado = [];
            let colores_backorders = [];
            let totales_fullfiled = [];
            let totales_unfullfiled = [];
            let totales_pausados = [];
            let totales_cancelados = [];
            let totales_backorders = [];

            for(let i = 0; i<data.body.orden.length; i++){

              labels.push(data.body.orden[i][0]);

              for (let index = 0; index < data.body.orden[i][1].length; index++) {
                switch (data.body.orden[i][1][index].estado) {
                  case "fulfilled": 
                    totales_fullfiled.push(parseInt(data.body.orden[i][1][index].total));
                    colores_fulfilled.push(this.colores[0]);
                    break;
                  case "unfulfilled":
                    totales_unfullfiled.push(parseInt(data.body.orden[i][1][index].total));
                    colores_unfullfiled.push(this.colores[1]);
                    break;
                  case "pausado":
                    totales_pausados.push(parseInt(data.body.orden[i][1][index].total));
                    colores_pausado.push(this.colores[2]);
                    break;
                  case "cancelado,Orden_Cancelada,cancelled,fulfilled_by_seller,refunded":
                    totales_cancelados.push(parseInt(data.body.orden[i][1][index].total));
                    colores_cancelado.push(this.colores[3]);
                    break;
                  case "unfulfilled_bo":
                    totales_backorders.push(parseInt(data.body.orden[i][1][index].total));
                    colores_backorders.push(this.colores[4]);
                    break;
                }
              }
            }

            datos_completos.push({
              label: 'Fulfilled',
              data: totales_fullfiled,
              backgroundColor: colores_fulfilled,
              borderColor: colores_fulfilled,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Unfulfilled',
              data: totales_unfullfiled,
              backgroundColor: colores_unfullfiled,
              borderColor: colores_unfullfiled,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Pausado',
              data: totales_pausados,
              backgroundColor: colores_pausado,
              borderColor: colores_pausado,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Cancelado',
              data: totales_cancelados,
              backgroundColor: colores_cancelado,
              borderColor: colores_cancelado,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Backorders',
              data: totales_backorders,
              backgroundColor: colores_backorders,
              borderColor: colores_backorders,
              borderWidth: 1
            });

            this.graficaEnviosEstatus(labels, datos_completos, tipo_grafica,alias_grafica);
          }
        },
      error => {
    });
  }

  graficaEnviosEstatus(labels, datos_completos, tipo_grafica,alias_grafica){
    document.getElementById(alias_grafica).remove();
    var canvas = document.createElement("canvas");
    canvas.id = alias_grafica; 
    document.getElementById("contenedor"+alias_grafica).appendChild(canvas);
    var ctx = document.getElementById(alias_grafica) as HTMLCanvasElement;
    var myChartEnviosEstatus = new Chart(ctx, {
        type: tipo_grafica,
        data: {
            labels: labels,
            datasets: datos_completos
        },
        options: {
          scales: {
            xAxes: [{
              stacked: true,
              barPercentage: 1,
              gridLines: {
                display: false
              },
              scaleLabel: {
                display: true,
                labelString: "Tiempo",
                fontColor: "black"
              }
            }],
            yAxes: [{
              stacked: true,
              gridLines: {
                zeroLineColor: "black",
                zeroLineWidth: 2
              },
              scaleLabel: {
                display: true,
                labelString: "Totales"
              },
              ticks: {
                beginAtZero: true
              }
            }]
          },
          elements: {
            rectangle: {
              borderSkipped: 'left',
            }
          }
        },
    });
  }

  consultarEstatusPorcentaje(item_id, filtro, tipo_grafica,alias_grafica){
    this.DashboardService.consultarEnviosEstatusPorcentaje(item_id, filtro)
    .pipe()
    .subscribe(
      data => {
          if(data.status == 200){
            let totales = [];
            let labels = []; 
            let colores = [];
            let bordes = [];

            for(let i = 0; i<data.body.orden.length; i++){
              let porcentaje = (parseInt(data.body.orden[i].total) * 100) / parseInt(data.body.orden[i].total_porcentaje);

              totales.push(porcentaje.toFixed(2));
              labels.push(data.body.orden[i].descripcion);

              switch (data.body.orden[i].estado) {
                case "fulfilled": 
                  colores.push(this.colores[0]);
                  bordes.push(this.colores[0]);
                  break;
                case "unfulfilled":
                  colores.push(this.colores[1]);
                  bordes.push(this.colores[1]);
                  break;
                case "pausado":
                  colores.push(this.colores[2]);
                  bordes.push(this.colores[2]);
                  break;
                case "cancelado,Orden_Cancelada,cancelled,fulfilled_by_seller,refunded":
                  colores.push(this.colores[3]);
                  bordes.push(this.colores[3]);
                  break;
                case "unfulfilled_bo":
                  colores.push(this.colores[4]);
                  bordes.push(this.colores[4]);
                  break;
              }
            }
            this.graficaEnviosEstatusPorcentaje(labels, totales, colores, bordes, tipo_grafica,alias_grafica);
          }
        },
      error => {
    });
  }

  graficaEnviosEstatusPorcentaje(labels, totales, colores, bordes, tipo_grafica,alias_grafica){
    document.getElementById(alias_grafica).remove();
    var canvas = document.createElement("canvas");
    canvas.id = alias_grafica; 
    document.getElementById("contenedor"+alias_grafica).appendChild(canvas);
    var ctx = document.getElementById(alias_grafica) as HTMLCanvasElement;
    var myChartEnviosPorcentaje = new Chart(ctx, {
        type: tipo_grafica,
        data: {
            labels: labels,
            datasets: [{
                label: '% envíos',
                data: totales,
                backgroundColor: colores,
                borderColor: colores,
                borderWidth: 1
            },]
        },
        options: {
          tooltips: {
              callbacks: {
                  label: (item, data) => data.datasets[item.datasetIndex].data[item.index].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '%'
              }
          },
        }
    });
  }

  consultarEstatusEntradas(item_id, filtro, tipo_grafica,alias_grafica){
    this.DashboardService.consultarEntradasEstatus(item_id, filtro)
    .pipe()
    .subscribe(
      data => {
          if(data.status == 200){

            let datos_completos = [];
            let labels = []; 
            let colores_abierta= [];
            let colores_proceso = [];
            let colores_closed = [];
            let colores_reabierta = [];

            let totales_abierta = [];
            let totales_proceso = [];
            let totales_closed = [];
            let totales_reabierta = [];


            for(let i = 0; i<data.body.orden.length; i++){

              labels.push(data.body.orden[i][0]);

              for (let index = 0; index < data.body.orden[i][1].length; index++) {
                switch (data.body.orden[i][1][index].estado) {
                  case "abierta": 
                    totales_abierta.push(parseInt(data.body.orden[i][1][index].total));
                    colores_abierta.push(this.colores[0]);
                    break;
                  case "proceso":
                    totales_proceso.push(parseInt(data.body.orden[i][1][index].total));
                    colores_proceso.push(this.colores[1]);
                    break;
                  case "closed":
                    totales_closed.push(parseInt(data.body.orden[i][1][index].total));
                    colores_closed.push(this.colores[2]);
                    break;
                  case "reabierta":
                    totales_reabierta.push(parseInt(data.body.orden[i][1][index].total));
                    colores_reabierta.push(this.colores[3]);
                    break;
                }
              }
            }

            datos_completos.push({
              label: 'Abierta',
              data: totales_abierta,
              backgroundColor: colores_abierta,
              borderColor: colores_abierta,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'En proceso',
              data: totales_proceso,
              backgroundColor: colores_proceso,
              borderColor: colores_proceso,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Cerrada',
              data: totales_closed,
              backgroundColor: colores_closed,
              borderColor: colores_closed,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Re-abierta',
              data: totales_reabierta,
              backgroundColor: colores_reabierta,
              borderColor: colores_reabierta,
              borderWidth: 1
            });

            this.graficaEntradasEstatus(labels, datos_completos, tipo_grafica,alias_grafica);
          }
        },
      error => {
    });
  }

  graficaEntradasEstatus(labels, datos_completos, tipo_grafica,alias_grafica){
    document.getElementById(alias_grafica).remove();
    var canvas = document.createElement("canvas");
    canvas.id = alias_grafica; 
    document.getElementById("contenedor"+alias_grafica).appendChild(canvas);
    var ctx = document.getElementById(alias_grafica) as HTMLCanvasElement;
    var myChartEnviosEstatus = new Chart(ctx, {
        type: tipo_grafica,
        data: {
            labels: labels,
            datasets: datos_completos
        },
        options: {
          scales: {
            xAxes: [{
              stacked: true,
              barPercentage: 1,
              gridLines: {
                display: false
              },
              scaleLabel: {
                display: true,
                labelString: "Tiempo",
                fontColor: "black"
              }
            }],
            yAxes: [{
              stacked: true,
              gridLines: {
                zeroLineColor: "black",
                zeroLineWidth: 2
              },
              scaleLabel: {
                display: true,
                labelString: "Totales"
              },
              ticks: {
                beginAtZero: true
              }
            }]
          },
          elements: {
            rectangle: {
              borderSkipped: 'left',
            }
          }
        },
    });
  }

  consultarEstatusDevoluciones(item_id, filtro, tipo_grafica,alias_grafica){
    this.DashboardService.consultarDevolucionesEstatus(item_id, filtro)
    .pipe()
    .subscribe(
      data => {
          if(data.status == 200){

            let datos_completos = [];
            let labels = []; 
            let colores_abierta= [];
            let colores_proceso = [];
            let colores_closed = [];
            let colores_reabierta = [];
            let colores_en_revision = [];
            let colores_pausadas = [];
            let colores_canceladas = [];

            let totales_abierta = [];
            let totales_proceso = [];
            let totales_closed = [];
            let totales_reabierta = [];
            let totales_en_revision = [];
            let totales_pausadas = [];
            let totales_canceladas = [];

            for(let i = 0; i<data.body.orden.length; i++){

              labels.push(data.body.orden[i][0]);

              for (let index = 0; index < data.body.orden[i][1].length; index++) {
                switch (data.body.orden[i][1][index].estado) {
                  case "abierta": 
                    totales_abierta.push(parseInt(data.body.orden[i][1][index].total));
                    colores_abierta.push(this.colores[0]);
                    break;
                  case "en_proceso":
                    totales_proceso.push(parseInt(data.body.orden[i][1][index].total));
                    colores_proceso.push(this.colores[1]);
                    break;
                  case "closed":
                    totales_closed.push(parseInt(data.body.orden[i][1][index].total));
                    colores_closed.push(this.colores[2]);
                    break;
                  case "reabierta":
                    totales_reabierta.push(parseInt(data.body.orden[i][1][index].total));
                    colores_reabierta.push(this.colores[3]);
                    break;
                  case "en_revision":
                    totales_en_revision.push(parseInt(data.body.orden[i][1][index].total));
                    colores_en_revision.push("#706c99");
                    break;
                  case "pausada":
                    totales_pausadas.push(parseInt(data.body.orden[i][1][index].total));
                    colores_pausadas.push("#3a76e8");
                    break;
                  case "cancelada":
                    totales_canceladas.push(parseInt(data.body.orden[i][1][index].total));
                    colores_canceladas.push("#ff0505");
                    break;
                }
              }
            }

            datos_completos.push({
              label: 'Abierta',
              data: totales_abierta,
              backgroundColor: colores_abierta,
              borderColor: colores_abierta,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'En proceso',
              data: totales_proceso,
              backgroundColor: colores_proceso,
              borderColor: colores_proceso,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Cerrada',
              data: totales_closed,
              backgroundColor: colores_closed,
              borderColor: colores_closed,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Re-abierta',
              data: totales_reabierta,
              backgroundColor: colores_reabierta,
              borderColor: colores_reabierta,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'En revisión',
              data: totales_en_revision,
              backgroundColor: colores_en_revision,
              borderColor: colores_en_revision,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Pausada',
              data: totales_pausadas,
              backgroundColor: colores_pausadas,
              borderColor: colores_pausadas,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Cancelada',
              data: totales_canceladas,
              backgroundColor: colores_canceladas,
              borderColor: colores_canceladas,
              borderWidth: 1
            });

            this.graficaDevolucionesEstatus(labels, datos_completos, tipo_grafica,alias_grafica);
          }
        },
      error => {
    });
  }

  graficaDevolucionesEstatus(labels, datos_completos, tipo_grafica,alias_grafica){
    document.getElementById(alias_grafica).remove();
    var canvas = document.createElement("canvas");
    canvas.id = alias_grafica; 
    document.getElementById("contenedor"+alias_grafica).appendChild(canvas);
    var ctx = document.getElementById(alias_grafica) as HTMLCanvasElement;
    var myChartEnviosEstatus = new Chart(ctx, {
        type: tipo_grafica,
        data: {
            labels: labels,
            datasets: datos_completos
        },
        options: {
          scales: {
            xAxes: [{
              stacked: true,
              barPercentage: 1,
              gridLines: {
                display: false
              },
              scaleLabel: {
                display: true,
                labelString: "Tiempo",
                fontColor: "black"
              }
            }],
            yAxes: [{
              stacked: true,
              gridLines: {
                zeroLineColor: "black",
                zeroLineWidth: 2
              },
              scaleLabel: {
                display: true,
                labelString: "Totales"
              },
              ticks: {
                beginAtZero: true
              }
            }]
          },
          elements: {
            rectangle: {
              borderSkipped: 'left',
            }
          }
        },
    });
  }

  consultarEstatusTickets(item_id, filtro, tipo_grafica,alias_grafica){
    this.DashboardService.consultarTicketsEstatus(item_id, filtro)
    .pipe()
    .subscribe(
      data => {
          if(data.status == 200){

            let datos_completos = [];
            let labels = []; 
            let colores_abierta= [];
            let colores_closed = [];
            let colores_reabierta = [];

            let totales_abierta = [];
            let totales_closed = [];
            let totales_reabierta = [];

            for(let i = 0; i<data.body.orden.length; i++){

              labels.push(data.body.orden[i][0]);

              for (let index = 0; index < data.body.orden[i][1].length; index++) {
                switch (data.body.orden[i][1][index].estado) {
                  case "1": 
                    totales_abierta.push(parseInt(data.body.orden[i][1][index].total));
                    colores_abierta.push(this.colores[0]);
                    break;
                  case "2":
                    totales_closed.push(parseInt(data.body.orden[i][1][index].total));
                    colores_closed.push(this.colores[2]);
                    break;
                  case "3":
                    totales_reabierta.push(parseInt(data.body.orden[i][1][index].total));
                    colores_reabierta.push(this.colores[3]);
                    break;
                }
              }
            }

            datos_completos.push({
              label: 'Abierta',
              data: totales_abierta,
              backgroundColor: colores_abierta,
              borderColor: colores_abierta,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Cerrada',
              data: totales_closed,
              backgroundColor: colores_closed,
              borderColor: colores_closed,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Re-abierta',
              data: totales_reabierta,
              backgroundColor: colores_reabierta,
              borderColor: colores_reabierta,
              borderWidth: 1
            });

            this.graficaTicketsEstatus(labels, datos_completos, tipo_grafica,alias_grafica);
          }
        },
      error => {
    });
  }

  graficaTicketsEstatus(labels, datos_completos, tipo_grafica,alias_grafica){
    document.getElementById(alias_grafica).remove();
    var canvas = document.createElement("canvas");
    canvas.id = alias_grafica; 
    document.getElementById("contenedor"+alias_grafica).appendChild(canvas);
    var ctx = document.getElementById(alias_grafica) as HTMLCanvasElement;
    var myChartEnviosEstatus = new Chart(ctx, {
        type: tipo_grafica,
        data: {
            labels: labels,
            datasets: datos_completos
        },
        options: {
          scales: {
            xAxes: [{
              stacked: true,
              barPercentage: 1,
              gridLines: {
                display: false
              },
              scaleLabel: {
                display: true,
                labelString: "Tiempo",
                fontColor: "black"
              }
            }],
            yAxes: [{
              stacked: true,
              gridLines: {
                zeroLineColor: "black",
                zeroLineWidth: 2
              },
              scaleLabel: {
                display: true,
                labelString: "Totales"
              },
              ticks: {
                beginAtZero: true
              }
            }]
          },
          elements: {
            rectangle: {
              borderSkipped: 'left',
            }
          }
        },
    });
  }

  consultarMotivoTickets(item_id, filtro, tipo_grafica,alias_grafica){
    this.DashboardService.consultarTicketsMotivo(item_id, filtro)
    .pipe()
    .subscribe(
      data => {
          if(data.status == 200){

            let datos_completos = [];
            let labels = []; 

            let colores_demora = [];
            let colores_extravio = [];
            let colores_daño_trancito = [];
            let colores_pedido_incompleto = [];
            let colores_producto_equivocado = [];
            let colores_robo = [];
            let colores_otro = [];

            let totales_demora = [];
            let totales_extravio = [];
            let totales_daño_trancito = [];
            let totales_pedido_incompleto = [];
            let totales_producto_equivocado = [];
            let totales_robo = [];
            let totales_otro = [];

            for(let i = 0; i<data.body.orden.length; i++){

              labels.push(data.body.orden[i][0]);

              for (let index = 0; index < data.body.orden[i][1].length; index++) {
                switch (data.body.orden[i][1][index].estado) {
                  case "1": 
                    totales_demora.push(parseInt(data.body.orden[i][1][index].total));
                    colores_demora.push(this.colores[0]);
                    break;
                  case "2":
                    totales_extravio.push(parseInt(data.body.orden[i][1][index].total));
                    colores_extravio.push(this.colores[1]);
                    break;
                  case "3":
                    totales_daño_trancito.push(parseInt(data.body.orden[i][1][index].total));
                    colores_daño_trancito.push(this.colores[2]);
                    break;
                  case "4":
                    totales_pedido_incompleto.push(parseInt(data.body.orden[i][1][index].total));
                    colores_pedido_incompleto.push(this.colores[3]);
                    break;
                  case "5":
                    totales_producto_equivocado.push(parseInt(data.body.orden[i][1][index].total));
                    colores_producto_equivocado.push(this.colores[4]);
                    break;
                  case "6":
                    totales_robo.push(parseInt(data.body.orden[i][1][index].total));
                    colores_robo.push(this.colores[5]);
                    break;
                  case "7":
                    totales_otro.push(parseInt(data.body.orden[i][1][index].total));
                    colores_otro.push(this.colores[6]);
                    break;
                }
              }
            }

            datos_completos.push({
              label: 'Demora',
              data: totales_demora,
              backgroundColor: colores_demora,
              borderColor: colores_demora,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Extravio',
              data: totales_extravio,
              backgroundColor: colores_extravio,
              borderColor: colores_extravio,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Daño en transito',
              data: totales_daño_trancito,
              backgroundColor: colores_daño_trancito,
              borderColor: colores_daño_trancito,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Pedido incompleto',
              data: totales_pedido_incompleto,
              backgroundColor: colores_pedido_incompleto,
              borderColor: colores_pedido_incompleto,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Producto equivocado',
              data: totales_producto_equivocado,
              backgroundColor: colores_producto_equivocado,
              borderColor: colores_producto_equivocado,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Robo',
              data: totales_robo,
              backgroundColor: colores_robo,
              borderColor: colores_robo,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Otro',
              data: totales_otro,
              backgroundColor: colores_otro,
              borderColor: colores_otro,
              borderWidth: 1
            });

            this.graficaMotivoEstatus(labels, datos_completos, tipo_grafica,alias_grafica);
          }
        },
      error => {
    });
  }

  graficaMotivoEstatus(labels, datos_completos, tipo_grafica,alias_grafica){
    document.getElementById(alias_grafica).remove();
    var canvas = document.createElement("canvas");
    canvas.id = alias_grafica; 
    document.getElementById("contenedor"+alias_grafica).appendChild(canvas);
    var ctx = document.getElementById(alias_grafica) as HTMLCanvasElement;
    var myChartEnviosEstatus = new Chart(ctx, {
        type: tipo_grafica,
        data: {
            labels: labels,
            datasets: datos_completos
        },
        options: {
          scales: {
            xAxes: [{
              stacked: true,
              barPercentage: 1,
              gridLines: {
                display: false
              },
              scaleLabel: {
                display: true,
                labelString: "Tiempo",
                fontColor: "black"
              }
            }],
            yAxes: [{
              stacked: true,
              gridLines: {
                zeroLineColor: "black",
                zeroLineWidth: 2
              },
              scaleLabel: {
                display: true,
                labelString: "Totales"
              },
              ticks: {
                beginAtZero: true
              }
            }]
          },
          elements: {
            rectangle: {
              borderSkipped: 'left',
            }
          }
        },
    });
  }

  consultarGraficaEstatusEnvios(item_id, filtro, tipo_grafica,alias_grafica){
    this.DashboardService.consultarDatosGraficaEstatusEnvio(item_id, filtro)
    .pipe()
    .subscribe(
      data => {
          if(data.status == 200){

            let datos_completos = [];
            let labels = []; 

            let colores_guia_creada = [];
            let colores_guia_transito = [];
            let colores_entregada = [];
            let colores_demorada = [];

            let totales_guia_creada = [];
            let totales_guia_transito = [];
            let totales_entregada = [];
            let totales_demorada = [];

            for(let i = 0; i<data.body.orden.length; i++){

              labels.push(data.body.orden[i][0]);

              for (let index = 0; index < data.body.orden[i][1].length; index++) {
                switch (data.body.orden[i][1][index].estado) {
                  case "guia_creada": 
                    totales_guia_creada.push(parseInt(data.body.orden[i][1][index].total));
                    colores_guia_creada.push(this.colores[0]);
                    break;
                  case "guia_transito":
                    totales_guia_transito.push(parseInt(data.body.orden[i][1][index].total));
                    colores_guia_transito.push(this.colores[1]);
                    break;
                  case "entregada":
                    totales_entregada.push(parseInt(data.body.orden[i][1][index].total));
                    colores_entregada.push(this.colores[2]);
                    break;
                  case "demorada":
                    totales_demorada.push(parseInt(data.body.orden[i][1][index].total));
                    colores_demorada.push(this.colores[3]);
                    break;
                }
              }
            }

            datos_completos.push({
              label: 'Guía creada',
              data: totales_guia_creada,
              backgroundColor: colores_guia_creada,
              borderColor: colores_guia_creada,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'En tránsito',
              data: totales_guia_transito,
              backgroundColor: colores_guia_transito,
              borderColor: colores_guia_transito,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Entregada',
              data: totales_entregada,
              backgroundColor: colores_entregada,
              borderColor: colores_entregada,
              borderWidth: 1
            });

            datos_completos.push({
              label: 'Demorada',
              data: totales_demorada,
              backgroundColor: colores_demorada,
              borderColor: colores_demorada,
              borderWidth: 1
            });

            this.graficaEstatusEnvios(labels, datos_completos, tipo_grafica,alias_grafica);
          }
        },
      error => {
    });
  }

  graficaEstatusEnvios(labels, datos_completos, tipo_grafica,alias_grafica){
    document.getElementById(alias_grafica).remove();
    var canvas = document.createElement("canvas");
    canvas.id = alias_grafica; 
    document.getElementById("contenedor"+alias_grafica).appendChild(canvas);
    var ctx = document.getElementById(alias_grafica) as HTMLCanvasElement;
    var myChartEnviosEstatus = new Chart(ctx, {
        type: tipo_grafica,
        data: {
            labels: labels,
            datasets: datos_completos
        },
        options: {
          scales: {
            xAxes: [{
              stacked: true,
              barPercentage: 1,
              gridLines: {
                display: false
              },
              scaleLabel: {
                display: true,
                labelString: "Tiempo",
                fontColor: "black"
              }
            }],
            yAxes: [{
              stacked: true,
              gridLines: {
                zeroLineColor: "black",
                zeroLineWidth: 2
              },
              scaleLabel: {
                display: true,
                labelString: "Totales"
              },
              ticks: {
                beginAtZero: true
              }
            }]
          },
          elements: {
            rectangle: {
              borderSkipped: 'left',
            }
          }
        },
    });
  }

  abrirModal(){
    this.DashboardService.consultarGraficasSeller(this.user["seller_id"])
    .pipe()
    .subscribe(
      data => {
        if(data.status == 200){
          const dialogRef3 = this.dialog.open(DialogConfiguracionGeneral ,{ width:'65vw', height: '90%',disableClose: true ,data: {params: data} });
        }
      },
      error => {}
    );
  }

  graficasSeller(){
    this.DashboardService.consultarGraficasSeller(this.user["seller_id"])
    .pipe()
    .subscribe(
      data => {
        if(data.status == 200){
          this.graficas = data.body.orden;
          this.graficas.forEach(element => {
            if(element.nombre_grafica =="myChartEnviosTotales"){
              let filtro = "0";
              if(element.tiempo == 0){
                filtro = this.filtro;
              }else{
                filtro = element.tiempo;
              }
              this.consultarTotales(this.user["seller_id"],filtro,element.tipo_grafica,element.alias_grafica);
            }
            if(element.nombre_grafica =="myChartEnviosEstatus"){
              let filtro = "0";
              if(element.tiempo == 0){
                filtro = this.filtro;
              }else{
                filtro = element.tiempo;
              }
              this.consultarEstatus(this.user["seller_id"],filtro,element.tipo_grafica,element.alias_grafica);
            }
            if(element.nombre_grafica =="myChartEnviosPorcentaje"){
              let filtro = "0";
              if(element.tiempo == 0){
                filtro = this.filtro;
              }else{
                filtro = element.tiempo;
              }
              this.consultarEstatusPorcentaje(this.user["seller_id"],filtro,element.tipo_grafica,element.alias_grafica);
            }
            if(element.nombre_grafica =="myChartEntradasEstatus"){
              let filtro = "0";
              if(element.tiempo == 0){
                filtro = this.filtro;
              }else{
                filtro = element.tiempo;
              }
              this.consultarEstatusEntradas(this.user["seller_id"],filtro,element.tipo_grafica,element.alias_grafica);
            }
            if(element.nombre_grafica =="myChartDevolucionesEstatus"){
              let filtro = "0";
              if(element.tiempo == 0){
                filtro = this.filtro;
              }else{
                filtro = element.tiempo;
              }
              this.consultarEstatusDevoluciones(this.user["seller_id"],filtro,element.tipo_grafica,element.alias_grafica);
            }
            if(element.nombre_grafica =="myChartTicketsEstatus"){
              let filtro = "0";
              if(element.tiempo == 0){
                filtro = this.filtro;
              }else{
                filtro = element.tiempo;
              }
              this.consultarEstatusTickets(this.user["seller_id"],filtro,element.tipo_grafica,element.alias_grafica);
            }
            if(element.nombre_grafica =="myChartTicketsMotivo"){
              let filtro = "0";
              if(element.tiempo == 0){
                filtro = this.filtro;
              }else{
                filtro = element.tiempo;
              }
              this.consultarMotivoTickets(this.user["seller_id"],filtro,element.tipo_grafica,element.alias_grafica);
            }
            if(element.nombre_grafica =="myChartTotalEnviosStatus"){
              let filtro = "0";
              if(element.tiempo == 0){
                filtro = this.filtro;
              }else{
                filtro = element.tiempo;
              }
              this.consultarGraficaEstatusEnvios(this.user["seller_id"],filtro,element.tipo_grafica,element.alias_grafica);
            }
          });
        }
      },
      error => {}
    );
  }

  drop(event: CdkDragDrop<string[]>) {
    this.DashboardService.guardarOrdenGraficas(this.graficas[event.previousIndex],this.graficas[event.currentIndex])
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.snackBar.open(data.message, "OK", {                      
            duration: 3500,
          });
          this.graficasSeller();
          this.reload();
        }else{
          this.snackBar.open(data.message, "OK", {                      
            duration: 4500,
          });
        }
      },
      error => {
        this.snackBar.open(error, "OK", {                      
          duration: 3500,
        });
      }
    );
  }

  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue
    
  }

  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);  
  }

  ml_refresh_token_expiration() {
    this.DashboardService.ml_refresh_token_expiration(this.user["seller_id"]).subscribe(
      response => {
        if (response.body && response.body.store_auths && response.body.store_auths.length > 0) {
          this.ml_refresh_token_expirations = response.body.store_auths;
        }
      },
      error => {
        this.snackBar.open(error, "OK", {                      
          duration: 3500,
        });
      }
    );
  }

  tik_tok_refresh_token_expiration() {
    this.DashboardService.tik_tok_refresh_token_expiration(this.user["seller_id"]).subscribe(
      response => {
        if (response.body && response.body.store_auths && response.body.store_auths.length > 0) {
          this.tik_tok_refresh_token_expirations = response.body.store_auths;
        }
      },
      error => {
        this.snackBar.open(error, "OK", {                      
          duration: 3500,
        });
      }
    );
  }

  cargarDashboard(): void {
    this.isLoading = true;
    this.hasError = false;
    this.authenticationService.obtenerMetabaseDashboardUrl()
      .pipe(first())
      .subscribe(
        data => {
          console.log('Metabase response:', data);
          if (data.status === 200 && data.body && data.body.url) {
            this.metabaseUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.body.url);
            console.log('Metabase URL set:', this.metabaseUrl);
          } else {
            this.hasError = true;
          }
            this.isLoading = false;
        },
          error => {
          console.log('Metabase error:', error);
          this.hasError = true;
          this.isLoading = false;
        }
      );
  }
}

export interface ShowDatGraphics {
  nombre: string;
  opcion: string;
  tipo: string;
}
@Component({
  providers:[DashboardsComponent ],
  selector: 'dialog-configuracion-general',
  templateUrl: './dialog-configuracion-general.html',
})

export class DialogConfiguracionGeneral {
  datos_tabla: ShowDatGraphics[] = [];
  datos_tabla_seller: ShowDatGraphics[] = [];
  displayedColumns = ['nombre','tipo','tiempo','opcion'];
  loading = false;
  error: string;
  mensaje_success = false;
  spinner = false;
  public graficas:any;
  public tipo_graficas:any;
  public temporalidad:any;
  user: any;
  btn_disabled = false;
  current_user       : any

  constructor(
    private authenticationService: AuthenticationService,
    private DashboardService: DashboardService,
    public dialogRef: MatDialogRef<DialogConfiguracionGeneral>,
    private router: Router,
    private snackBar: MatSnackBar,
    public comp : DashboardsComponent,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
      if(this.data.params){
        this.datos_tabla = this.data.params.body.graficas;
      }
      this.datos_tabla = this.datos_tabla.filter((value,key)=>{
        return value;
      });

      if(this.data.params){
        this.datos_tabla_seller = this.data.params.body.orden;
      }
      this.datos_tabla_seller = this.datos_tabla_seller.filter((value,key)=>{
        return value;
      });
  }

  ngOnInit(){
    this.asignarDatos(); 
    this.authenticationService.currentUser.subscribe(x => this.user = x);
    this.tipo_graficas = [{tipo:"bar",descripcion:"Barras"},{tipo:"line",descripcion:"Lineal"},{tipo:"pie",descripcion:"Pie"}];
    this.temporalidad = [{id:0,descripcion:"Dinámico"},{id:1,descripcion:"Día"},{id:2,descripcion:"Semana"},{id:3,descripcion:"Mes"},{id:4,descripcion:"Año"},{id:5,descripcion:"Total"}];
    this.graficasSeller();
  }

  graficasSeller(){
    this.DashboardService.consultarGraficasSeller(this.user["seller_id"])
    .pipe()
    .subscribe(
      data => {
        if(data.status == 200){
          this.graficas = data.body.orden;
          this.datos_tabla_seller = data.body.orden;
        }
      },
      error => {}
    );
  }

  guardar(datos,tipo_accion){
    this.DashboardService.guardarConfiguracionSeller(datos, this.user["seller_id"],tipo_accion)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.snackBar.open(data.message, "OK", {                      
            duration: 3500,
          });
          this.graficasSeller();
          this.comp.reload();
        }else{
          this.snackBar.open(data.message, "OK", {                      
            duration: 4500,
          });
        }
      },
      error => {
        this.snackBar.open(error, "OK", {                      
          duration: 3500,
        });
      }
    );
  }

  valida_configuracion(datos){
    this.DashboardService.validaConfiguracionSeller(datos, this.user["seller_id"])
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.btn_disabled = false;
        }else{
          this.btn_disabled = true;
          this.snackBar.open(data.message, "OK", {                      
            duration: 4500,
          });
        }
      },
      error => {
        this.snackBar.open(error, "OK", {                      
          duration: 3500,
        });
      }
    );
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue
    
  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);  
  }
}

